import React, { useState } from "react";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { validarRequisito } from "../services/expediente.service";
import { obtenerDocumento } from "../services/uploadFile.service";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import UploadFileRequest from "./UploadFileRequest";

export default function VerificarRequisito({
  setIsVisibleModal,
  setReload,
  reload,
  id_expediente,
  requisito,
}) {
  const [value, setValue] = React.useState("");
  const [showSolicitarMotivo, setShowSolicitarMotivo] = React.useState(false);
  const [motivo, setMotivo] = React.useState("");
  const [saveClicked, setSaveClicked] = useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
    setShowSolicitarMotivo(event.target.value === "3");
  };

  const handleMotivoChange = (event) => {
    setMotivo(event.target.value);
  };

  const onClose = () => {
    setIsVisibleModal(false);
    setShowSolicitarMotivo(false);
    setMotivo("");
    setValue("");
  };

  const saveAction = async (uploadedFiles) => {
    try {
      const data = {
        id_estado: value,
        id_mov: requisito.id_mov,
        id_file: uploadedFiles?.length > 0 ? uploadedFiles[0].fileId : null,
        detalle_respuesta: motivo,
      };
      const result = await validarRequisito(data);
      if (result.data) {
        setReload(!reload);
        onClose();
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  const handleSaveClick = () => {
    if (value === "2") {
      saveAction([]);
    } else {
      setSaveClicked(true);
    }
  };

  const getFile = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  return (
    <>
      {(requisito.mov_respuesta_obs || requisito.mov_respuesta_file_id) && (
        <Grid
          item
          xs={12}
          style={{
            marginBottom: 20,
            border: "2px solid green", // Borde de 2px de color rojo
            borderRadius: "8px", // Bordes ligeramente redondeados
            padding: "10px", // Opcional: añadir padding para que el contenido no esté pegado al borde
          }}
        >
          {requisito.mov_respuesta_obs && (
            <Typography variant="body1">
              RESPUESTA: {requisito.mov_respuesta_obs}
            </Typography>
          )}
          {requisito.mov_respuesta_file_id && (
            <div
              onClick={() => getFile(requisito.respuesta_file_url)}
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
              }}
            >
              <DescriptionOutlinedIcon style={{ fontSize: 40 }} />
              <Typography variant="body2">
                {requisito.respuesta_file_nombre}
              </Typography>
            </div>
          )}
        </Grid>
      )}
      {showSolicitarMotivo && (
        <>
          <Grid item xs={12} style={{ marginTop: 15, marginBottom: 10 }}>
            <TextField
              label="Por favor ingrese un motivo de rechazo"
              size="small"
              name="title"
              value={motivo}
              multiline
              minRows={4}
              onChange={handleMotivoChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 10 }}>
            <UploadFileRequest
              setIsVisibleModal={setIsVisibleModal}
              setReload={setReload}
              reload={reload}
              id_expediente={id_expediente}
              requisito={requisito}
              saveClicked={saveClicked}
              callback={saveAction}
              label={"Puede adjuntar un archivo si lo considera necesario"}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <FormControl component="fieldset">
          <RadioGroup row value={value} onChange={handleChange}>
            <FormControlLabel
              value="2"
              control={<Radio color="primary" />}
              label="Sí"
            />
            <FormControlLabel
              value="3"
              control={<Radio color="primary" />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between">
          <ButtonComponent
            name="Guardar"
            toAction={handleSaveClick}
            disabled={value === ""}
          />
          <div style={{ width: "5px" }}></div>
          <ButtonComponent
            name="Cancelar"
            toAction={onClose}
            color={COLORS.DANGER}
          />
        </Box>
      </Grid>
    </>
  );
}
